import { useEffect, useState } from 'react';
import Deployments from '../../types/Deployments';
import DataStoreService from '../../services/DataStoreService';

export default function useDataStores(projectUuid?: string) {
    const [loading, setLoading] = useState<boolean>(true);
    const [updating, setUpdating] = useState<boolean>(false);
    const [dataStores, setDataStores] = useState<Deployments | undefined>(
        undefined
    );
    const [error, setError] = useState<string | null>(null);

    const load = async () => {
        if (projectUuid) {
            try {
                const result = await DataStoreService.getDataStores();
                setDataStores(result);
            } catch (err: any) {
                console.error(err);
                setError(err);
            }
        } else {
            setError('No project selected defined');
        }
    };

    const refresh = () => {
        const update = async () => {
            setUpdating(true);
            await load();
            setUpdating(false);
        };
        update();
    };

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            await load();
            setLoading(false);
        };

        if (!dataStores) {
            init();
        } else {
            refresh();
        }
    }, [projectUuid]);

    return { dataStores, error, loading, refresh, updating };
}
